import React from 'react'
import { Link } from 'react-router-dom';
import { ChevronDown, Menu, X, Users, Scale, User, MapPin, Phone, Mail } from 'lucide-react';

const Header = () => {
    return (
        <header className="bg-white border-b border-gray-300">
            <div className="pr-4 sm:pr-6 lg:pr-8">
                <div className="flex justify-between items-center h-20">
                    <div className="flex items-center">
                        <Link to="/">
                            <img src="/30_years_new_Logo-01 1.png" alt="Anand Rathi Logo" className="h-16 sm:h-20" />
                        </Link>
                    </div>

                    {/* Desktop Navigation */}
                    <nav className="hidden md:flex space-x-4 lg:space-x-8 text-gray-800 font-semibold text-sm lg:text-base">
                        <div className="relative">
                            <button
                                onClick={() => toggleDropdown('group')}
                                className="flex items-center hover:text-yellow-700 transition"
                            >
                                GROUP <ChevronDown className="ml-1 h-4 w-4" />
                            </button>
                            {dropdownOpen.group && (
                                <div className="absolute top-full left-0 mt-1 w-48 bg-white shadow-lg border rounded-md z-50">
                                    <Link to="/about" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">About</Link>
                                    <Link to="/leadership" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">Leadership</Link>
                                    {/* <a href="#" className="block px-4 py-2 text-gray-700 hover:bg-gray-100">Our Journey</a> */}
                                </div>
                            )}
                        </div>
                        {/* <button className="flex items-center hover:text-yellow-700 transition">
                            BUSINESSES
                        </button>
                        <button className="hover:text-yellow-700 transition">MEDIA</button>
                        <button className="flex items-center hover:text-yellow-700 transition">
                            CAREER
                        </button> */}
                        <Link to="/contact" className="hover:text-yellow-700 transition">CONTACT</Link>
                    </nav>

                    {/* Mobile menu button */}
                    <button
                        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                        className="md:hidden p-2"
                    >
                        {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                    </button>
                </div>

                {/* Mobile Navigation */}
                {mobileMenuOpen && (
                    <div className="md:hidden py-4 border-t">
                        <div className="space-y-2">
                            <div>
                                <button
                                    onClick={() => toggleDropdown('groupMobile')}
                                    className="flex items-center justify-between w-full px-4 py-2 text-gray-800 hover:bg-gray-100"
                                >
                                    GROUP <ChevronDown className="h-4 w-4" />
                                </button>
                                {dropdownOpen.groupMobile && (
                                    <div className="pl-4 space-y-1">
                                        <Link to="/about" className="block px-4 py-2 text-gray-600 hover:bg-gray-100">About</Link>
                                        <Link to="/leadership" className="block px-4 py-2 text-gray-600 hover:bg-gray-100">Leadership</Link>
                                        <a href="#" className="block px-4 py-2 text-gray-600 hover:bg-gray-100">Our Journey</a>
                                    </div>
                                )}
                            </div>
                            <button className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100">BUSINESSES</button>
                            <button className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100">MEDIA</button>
                            <button className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100">CAREER</button>
                            <Link to="/contact" className="block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100">CONTACT</Link>
                        </div>
                    </div>
                )}
            </div>
        </header>
    )
}

export default Header